import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Button, Divider, Form, Input } from "antd";
import { clubActions } from "../../actions/clubAction";
import Spinner from "../../components/spinner";
import { ErrorMessages, Role } from "../../actions/constants/common";
import { emailValidate } from "../../services/helper";
import SocialAuth from "../../components/socialOAuth";
import { commonConstants } from "../../actions/constants/commonConstant";
import env from "../../services/env";

const JoinClub: React.FC = () => {

    const [form] = Form.useForm()
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const join = useSelector((state: any) => state.joinMember);

    const host = window.location.host.split(".");
    const domainName = host[0]
    const location = useLocation();
    const AUTHDATA = localStorage.getItem('AUTHDATA');

    const [member, setMember] = useState({
        email: "",
        firstName: "",
        lastName: "",
        clubDomain: host.length > 1 ? host[0] : '',
        contactNumber: "",
        isSocialSigin: false
    });
    const [role, setRole] = useState("");

    const handleOnChange = (e: any) => {
        const { name, value } = e.target;
        setMember({ ...member, [name]: value });
    };

    const handleOnBack = () => {
        navigate(-1);
        if (join && join.isError) {
            join.isError = false;
        }
    }

    const handleSubmit = () => {
        dispatch(clubActions.joinMember(member))
    }

    const handleSocialAuthClick = (social: string) => {
        window.location.href = `${env.authUrl}/${social}?url=${window.location.href}`;
    };

    const handleHomeOnClick = () => {
        navigate('/');
    }

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const error = params.get('error');
        const success = params.get('success');
        if (error) {
            dispatch({ type: commonConstants.ShowErrorMessage, payload: error })
            navigate('/join');
        }
        if (success) {
            join.isSuccess = true
        }
    }, [])

    useEffect(() => {
        if (location.pathname === '/join') {
            if (join && join.isError) {
                join.isError = false;
            }
        }
    }, [location.pathname, join.isError]);

    useEffect(() => {
        if (AUTHDATA && AUTHDATA) {
            const parsedAuthData = JSON.parse(AUTHDATA);
            const authRole = parsedAuthData.role;
            setRole(authRole)
        }
    }, [AUTHDATA])

    return (
        <div className="border-form-wrapper">
            {join.isLoading && <Spinner />}
            {(join && !join.isSuccess && !join.isLoading) &&
                < div className='create-page form-border form-width forn-block'>
                    <div className="form-wrapper">
                        <div className='page-title' data-testid="pageTitle"> Join as a member</div>
                        <Form form={form} onFinish={handleSubmit} initialValues={member} colon={false}>
                            {join && join.isError && <div className="error-text" data-testid="error-text"> {join.error}</div>}
                            <Form.Item label="First Name" name="firstName" data-testid="firstNameLabel"
                                rules={[{ required: true, message: "First name is required!" }]}>
                                <Input data-testid="firstNameInput" name="firstName" onChange={handleOnChange} />
                            </Form.Item>
                            <Form.Item label="Last Name" name="lastName" data-testid="lastNameLabel">
                                <Input data-testid="lastNameInput" name="lastName" onChange={handleOnChange} />
                            </Form.Item>
                            <Form.Item label="Email" name="email" data-testid="emailLabel"
                                rules={[{ required: true, message: "Email is required!" },
                                ({ }) => ({
                                    validator(_) {
                                        if (!member.email) return Promise.resolve();
                                        if (!emailValidate(member.email)) return Promise.reject(new Error(ErrorMessages.invalidEmail));
                                        return Promise.resolve();
                                    }
                                })]}>
                                <Input name="email" data-testid="emailInput" onChange={handleOnChange} />
                            </Form.Item>
                            <Form.Item label="Contact Number" name="contactNumber" data-testid="whatsAppLabel" className="whatsapp-number"
                                rules={[{ required: false, message: "Contact number is required!" },
                                { message: "The input is not valid number", pattern: new RegExp(/^[0-9]+$/) }]} >
                                <Input name="contactNumber" data-testid="whatsAppInput" onChange={handleOnChange} maxLength={10} minLength={10} />
                            </Form.Item>
                            {Role.Member === role &&
                                <Form.Item label="Club Name">
                                    <Input readOnly value={domainName} name="clubName" />
                                </Form.Item>
                            }
                            <div className='button-groups'>
                                <Button type="primary" htmlType="button" data-testid="btnCancel" className="cancel-button" onClick={handleOnBack} > Cancel</Button>
                                <Button type="primary" htmlType="submit" data-testid="btnSubmit" className="join-button"> Join</Button>
                            </div>
                        </Form>
                        <Divider plain style={{ color: "gray" }} data-testid="txtValue">or continue with</Divider>
                        <SocialAuth handleSocialAuth={handleSocialAuthClick} />
                    </div>
                </div>}
            {(join.isSuccess) &&
                <div className="member-verified">
                    <h3 data-testid="success-mes">Thank you for joining us!</h3>
                    <div data-testid="success-mes1">We have sent a password update link to your email. <br data-testid="success-mes2" /> Please, check it and set up your new password.</div>
                    <Button data-testid="proceed-home" className="proceed-home" type="primary" onClick={handleHomeOnClick} >Home</Button>
                </div>}
        </div >
    )
}

export default JoinClub;